import React from "react";

import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";
import useOrderLineInfo from "@repo/shopify/hooks/useOrderLineInfo";
import type { IReturnLineItem } from "@repo/shopify/types/api/order";
import type { OrderLineItem } from "@repo/shopify/types/generated/storefront.types";

import Image from "@atoms/Image";
import Price from "@atoms/Price";

import { translationReturnReason } from "@const/constant";

interface IProps {
  node: OrderLineItem | IReturnLineItem;
}

export default function OrderLineItem({ node }: IProps) {
  const { isPC } = useCheckDevice();

  const { compareAtPrice, price } = useOrderLineInfo(node);

  return (
    <li className="pc:col-span-5 pc:grid-cols-subgrid col-span-8 grid grid-cols-subgrid">
      <div className="pc:col-span-3 pc:gap-5 col-span-6 flex gap-2">
        <Image
          className="pc:w-20 pc:min-w-20 h-fit w-15 min-w-15"
          height={node.variant?.image?.height || 1707}
          src={node.variant?.image?.url || ""}
          width={node.variant?.image?.width || 1280}
        />
        <div className="flex grow flex-col gap-1">
          <div>
            <span className="inline">{node.title}</span>
            <span className="ml-1 inline font-normal">{`${node.variant?.title.replace(" /", ",")}`}</span>
          </div>
          {!isPC && <span>Qty {node.quantity}</span>}
          {Boolean((node as IReturnLineItem).returnReason) && (
            <span>{translationReturnReason[(node as IReturnLineItem).returnReason as keyof typeof translationReturnReason]}</span>
          )}
        </div>
      </div>
      {isPC ? <span className="pc:col-span-1">Qty {node.quantity}</span> : null}
      <Price
        className="pc:col-span-1 col-span-2 text-right"
        compareAtPrice={compareAtPrice}
        direction="vertical"
        price={price}
        variant="secondary"
      />
    </li>
  );
}
